<template>
  <v-sheet class="py-6 px-8">
    <p class="text-h6 font-weight-bold grey--text text--darken-3 text-center mb-6">컨셉 추가하기</p>

    <v-sheet class="mt-2 px-4">
      <!-- 이미지 편집/미리보기 -->
      <v-sheet outlined class="rounded-10 pa-2 mt-2">
        <clipper-basic :src="url" ref="clipper1" class="my-clipper" :ratio="4 / 2.5" :init-width="100">
          <div class="placeholder d-flex align-center justify-center" slot="placeholder">
            <span class="text-caption grey--text">이미지 미리보기</span>
          </div>
        </clipper-basic>
      </v-sheet>

      <!-- 이미지 첨부 -->
      <v-sheet class="mt-4 mb-4" @drop.prevent="addDropFile" @dragover.prevent>
        <v-file-input class="rounded-10" outlined dense show-size hide-details prepend-icon color="primary" label="이미지" v-model="uploadImage" @change="onFileChange()">
          <template v-slot:prepend-inner>
            <v-icon class="mr-1" color="primary">mdi-image-filter-hdr</v-icon>
          </template>
        </v-file-input>
      </v-sheet>

      <div class="d-flex">
        <div style="width: 100%" class="mr-2">
          <!-- 이미지 편집/미리보기 -->
          <v-sheet outlined class="rounded-10 pa-2 mt-2">
            <clipper-basic :src="url2" ref="clipper2" class="my-clipper" :ratio="2.5 / 3" :init-width="100">
              <div class="placeholder d-flex align-center justify-center" slot="placeholder">
                <span class="text-caption grey--text">이미지 미리보기</span>
              </div>
            </clipper-basic>
          </v-sheet>

          <!-- 이미지 첨부 -->
          <v-sheet class="mt-4 mb-4" @drop.prevent="addDropFile2" @dragover.prevent>
            <v-file-input class="rounded-10" outlined dense show-size hide-details prepend-icon color="primary" label="패턴 1 이미지" v-model="uploadImage2" @change="onFileChange2()">
              <template v-slot:prepend-inner>
                <v-icon class="mr-1" color="primary">mdi-image-filter-hdr</v-icon>
              </template>
            </v-file-input>
          </v-sheet>
        </div>
        <div style="width: 100%">
          <!-- 이미지 편집/미리보기 -->
          <v-sheet outlined class="rounded-10 pa-2 mt-2">
            <clipper-basic :src="url3" ref="clipper3" class="my-clipper" :ratio="2.5 / 3" :init-width="100">
              <div class="placeholder d-flex align-center justify-center" slot="placeholder">
                <span class="text-caption grey--text">이미지 미리보기</span>
              </div>
            </clipper-basic>
          </v-sheet>

          <!-- 이미지 첨부 -->
          <v-sheet class="mt-4 mb-4" @drop.prevent="addDropFile3" @dragover.prevent>
            <v-file-input class="rounded-10" outlined dense show-size hide-details prepend-icon color="primary" label="패턴 2 이미지" v-model="uploadImage3" @change="onFileChange3()">
              <template v-slot:prepend-inner>
                <v-icon class="mr-1" color="primary">mdi-image-filter-hdr</v-icon>
              </template>
            </v-file-input>
          </v-sheet>
        </div>
      </div>
      <v-text-field class="rounded-10" label="제목(한글)" dense outlined v-model="create.title"></v-text-field>
      <v-text-field class="rounded-10" label="제목(영어)" dense outlined v-model="create.title_en"></v-text-field>
      <v-text-field class="rounded-10" label="제목(일어)" dense outlined v-model="create.title_jp"></v-text-field>
      <v-text-field class="rounded-10" label="가격" dense outlined type="number" hide-spin-buttons v-model="create.price"></v-text-field>
      <v-autocomplete class="rounded-10" label="태그" dense outlined multiple :items="select_list.tag" v-model="create.tag"></v-autocomplete>
      <v-text-field class="rounded-10" label="셔터스피드" dense outlined type="number" hide-spin-buttons v-model="create.shutter_speed"></v-text-field>
      <v-text-field class="rounded-10" label="조리개" dense outlined type="number" v-model="create.aperture"></v-text-field>
      <v-text-field class="rounded-10" label="ISO" dense outlined type="number" v-model="create.iso"></v-text-field>
      <v-text-field class="rounded-10" label="카메라" dense outlined type="number" v-model="create.camera"></v-text-field>
      <v-text-field class="rounded-10" label="조명(좌)" dense outlined v-model="create.light_left"></v-text-field>
      <v-text-field class="rounded-10" label="조명(우)" dense outlined v-model="create.light_right"></v-text-field>
      <v-text-field class="rounded-10" label="스튜디오" dense outlined v-model="create.studio_type"></v-text-field>
      <v-text-field class="rounded-10" label="포즈 설명" dense outlined v-model="create.pose_type"></v-text-field>
      <v-text-field class="rounded-10" label="위치 설명" dense outlined type="number" v-model="create.standing_type"></v-text-field>
      <v-text-field class="rounded-10" label="새도우" dense outlined v-model="create.shadow_json"></v-text-field>
      <v-select :items="select_list.status" class="rounded-10" label="상태" dense outlined v-model="create.status"></v-select>
      <v-text-field class="rounded-10" label="순서" dense outlined type="number" v-model="create.order"></v-text-field>

      <!-- 본문 -->
      <v-divider></v-divider>
      <v-sheet>
        <div class="d-flex justify-space-between align-center">
          <div class="font-weight-bold text-h6 ml-4 mt-4">한글</div>
          <v-btn color="primary" depressed outlined small @click="clear('ko')">삭제</v-btn>
        </div>

        <TipTapWriter class="tiptap_style" :options="options" :key="'ko' + componentKey" />
      </v-sheet>

      <v-sheet class="mt-4">
        <div class="d-flex justify-space-between align-center">
          <div class="font-weight-bold text-h6 ml-4 mt-4">영어</div>
          <v-btn color="primary" depressed outlined small @click="clear('en')">삭제</v-btn>
        </div>
        <TipTapWriter class="tiptap_style mt-2" :options="en.options" :key="'en' + en.componentKey" />
      </v-sheet>

      <v-sheet class="mt-4">
        <div class="d-flex justify-space-between align-center">
          <div class="font-weight-bold text-h6 ml-4 mt-4">일어</div>
          <v-btn color="primary" depressed outlined small @click="clear('jp')">삭제</v-btn>
        </div>
        <TipTapWriter class="tiptap_style mt-2" :options="jp.options" :key="'jp' + jp.componentKey" />
      </v-sheet>
    </v-sheet>
    <v-sheet class="d-flex justify-center mt-5">
      <v-btn class="rounded-10 px-6 mr-4" color="grey" large dark depressed @click="$emit('close')">
        <v-icon small left>mdi-cancel</v-icon>
        취소하기
      </v-btn>
      <v-btn class="rounded-10 px-6" color="primary" large dark depressed @click="createSubmit()">
        <v-icon small left>mdi-database-edit-outline</v-icon>
        추가하기
      </v-btn>
    </v-sheet>
  </v-sheet>
</template>
<script>
import TipTapWriter from "@/components/tiptap/Writer"
import TipTapReader from "@/components/tiptap/Reader"
import { AllTag, Tags } from "@/constant"

export default {
  components: {
    TipTapWriter,
    TipTapReader,
  },
  props: {
    src: {
      type: Object | undefined | null,
    },
  },

  data: () => ({
    select_list: {
      tag: Tags.map((e) => e.title),
      status: ["노출", "숨김"],
    },

    uploadImage: {},
    url: "",

    uploadImage2: {},
    url2: "",

    uploadImage3: {},
    url3: "",

    create: {
      thumbnail_image: "",
      pattern_1_image: "",
      pattern_2_image: "",
      title: "",
      title_en: "",
      title_jp: "",
      price: "",
      tag: "",
      status: "노출",
      shutter_speed: "",
      aperture: "",
      iso: "",
      camera: "",
      light_left: "",
      light_right: "",
      studio_type: "",
      pose_type: "",
      standing_type: "",
      shadow_json: "{'json':2}",
      order: 1,
    },

    //TipTap
    options: {
      content: "",
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    componentKey: 0,

    en: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },

    jp: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },
  }),

  mounted() {
    this.create.price = this.src.price
    if (this.src.tag) {
      this.create.tag = this.src.tag.split(",")
    }
    this.create.shutter_speed = this.src.shutter_speed
    this.create.aperture = this.src.aperture
    this.create.iso = this.src.iso
    this.create.camera = this.src.camera
    this.create.light_left = this.src.light_left
    this.create.light_right = this.src.light_right
    this.create.studio_type = this.src.studio_type
    this.create.pose_type = this.src.pose_type
    this.create.standing_type = this.src.standing_type
    this.create.shadow_json = this.src.shadow_json
    if (this.src.content) {
      this.options.content = this.src.content
    }
    this.componentKey++
    this.en.options.content = this.src.content_en
    this.en.componentKey++
    this.jp.options.content = this.src.content_jp
    this.jp.componentKey++
  },

  methods: {
    // 파일 드래그앤드롭
    addDropFile(e) {
      const file = e.dataTransfer.files[0]
      this.uploadImage = e.dataTransfer.files[0]
      this.url = URL.createObjectURL(file)
    },

    // 파일 선택시 이미지 표시
    onFileChange() {
      const file = this.uploadImage
      this.url = URL.createObjectURL(file)
    },

    // 파일 드래그앤드롭
    addDropFile2(e) {
      const file = e.dataTransfer.files[0]
      this.uploadImage = e.dataTransfer.files[0]
      this.url2 = URL.createObjectURL(file)
    },

    // 파일 선택시 이미지 표시
    onFileChange2() {
      const file = this.uploadImage2
      this.url2 = URL.createObjectURL(file)
    },

    // 파일 드래그앤드롭
    addDropFile3(e) {
      const file = e.dataTransfer.files[0]
      this.uploadImage = e.dataTransfer.files[0]
      this.url3 = URL.createObjectURL(file)
    },

    // 파일 선택시 이미지 표시
    onFileChange3() {
      const file = this.uploadImage3
      this.url3 = URL.createObjectURL(file)
    },

    // 이미지 업로드 (DB 입력)
    imageUpload: _.debounce(async function () {
      // Crop 이미지 파일로 변환
      const canvas = this.$refs.clipper1.clip() //call component's clip method
      var imgDataUrl = canvas.toDataURL("image/webp", 0.5) //canvas->image
      var binaryData = atob(imgDataUrl.split(",")[1])
      var array = []
      for (var i = 0; i < binaryData.length; i++) {
        array.push(binaryData.charCodeAt(i))
      }
      var file = new File([new Uint8Array(array)], "filename.png", { type: "image/png" })
      var formData = new FormData()
      formData.append("image", file)

      // 이미지 업로드
      await this.$http
        .post("/api/image/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            type: "concept/thumbnail_image",
          },
        })
        .then((res) => {
          this.create.thumbnail_image = res.data
        })

      // Crop 이미지 파일로 변환
      const canvas2 = this.$refs.clipper2.clip() //call component's clip method
      var imgDataUrl = canvas2.toDataURL("image/webp", 0.5) //canvas->image
      var binaryData = atob(imgDataUrl.split(",")[1])
      var array = []
      for (var i = 0; i < binaryData.length; i++) {
        array.push(binaryData.charCodeAt(i))
      }
      var file = new File([new Uint8Array(array)], "filename.png", { type: "image/png" })
      var formData = new FormData()
      formData.append("image", file)

      // 이미지 업로드
      await this.$http
        .post("/api/image/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            type: "concept/thumbnail_image",
          },
        })
        .then((res) => {
          this.create.pattern_1_image = res.data
        })

      // Crop 이미지 파일로 변환
      const canvas3 = this.$refs.clipper3.clip() //call component's clip method
      var imgDataUrl = canvas3.toDataURL("image/webp", 0.5) //canvas->image
      var binaryData = atob(imgDataUrl.split(",")[1])
      var array = []
      for (var i = 0; i < binaryData.length; i++) {
        array.push(binaryData.charCodeAt(i))
      }
      var file = new File([new Uint8Array(array)], "filename.png", { type: "image/png" })
      var formData = new FormData()
      formData.append("image", file)

      // 이미지 업로드
      await this.$http
        .post("/api/image/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            type: "concept/thumbnail_image",
          },
        })
        .then((res) => {
          this.create.pattern_2_image = res.data
        })

      console.log(this.create)

      // DB 입력
      await this.$http
        .post("/api/concept/insert", {
          params: {
            thumbnail_image: this.create.thumbnail_image,
            pattern_1_image: this.create.pattern_1_image,
            pattern_2_image: this.create.pattern_2_image,
            title: this.create.title,
            title_en: this.create.title_en,
            title_jp: this.create.title_jp,
            content: this.options.content,
            content_en: this.en.options.content,
            content_jp: this.jp.options.content,
            price: Number(this.create.price),
            tag: this.create.tag.toString(),
            status: this.create.status,
            shutter_speed: Number(this.create.shutter_speed),
            aperture: Number(this.create.aperture),
            iso: Number(this.create.iso),
            camera: Number(this.create.camera),
            light_left: this.create.light_left,
            light_right: this.create.light_right,
            studio_type: this.create.studio_type,
            pose_type: this.create.pose_type,
            standing_type: Number(this.create.standing_type),
            shadow_json: this.create.shadow_json,
            order: Number(this.create.order),
          },
        })
        .then((res) => {
          if (res.data.affectedRows) {
            alert("컨셉이 정상적으로 등록되었습니다")
            this.$emit("close")
          }
        })
    }, 500),

    // 목록
    async createSubmit() {
      // 업로드 이미지 검증
      if (!this.uploadImage || !(this.uploadImage instanceof File)) {
        alert("썸네일 이미지를 첨부해주세요")
        return
      }

      // 업로드 이미지 검증
      if (!this.uploadImage2 || !(this.uploadImage2 instanceof File)) {
        alert("패턴 1 이미지를 첨부해주세요")
        return
      }

      // 업로드 이미지 검증
      if (!this.uploadImage3 || !(this.uploadImage3 instanceof File)) {
        alert("패턴 2 이미지를 첨부해주세요")
        return
      }

      // 제목 검증
      if (this.create.title == "") {
        alert("제목을 입력해주세요")
        return
      }

      // 컨셉소개 내용 검증
      if (this.options.content == "") {
        alert("컨셉소개 내용을 입력해주세요")
        return
      }

      // 가격 검증
      if (this.create.price == "") {
        alert("가격을 입력해주세요")
        return
      }

      // 태그 검증
      if (this.create.tag.toString() == "") {
        alert("태그를 입력해주세요")
        return
      }

      // 셔터스피드 검증
      else if (this.create.shutter_speed == "") {
        alert("셔터스피드를 입력해주세요")
        return
      }

      // 조리개 검증
      else if (this.create.aperture == "") {
        alert("조리개을 입력해주세요")
        return
      }

      // ISO 검증
      else if (this.create.iso == "") {
        alert("ISO을 입력해주세요")
        return
      }

      // 카메라 검증
      else if (this.create.camera == "") {
        alert("카메라를 입력해주세요")
        return
      }

      // 조명(좌) 검증
      else if (this.create.light_left == "") {
        alert("조명(좌)을 입력해주세요")
        return
      }

      // 조명(우) 검증
      else if (this.create.light_right == "") {
        alert("조명(우)을 입력해주세요")
        return
      }

      // 스튜디오 검증
      else if (this.create.studio_type == "") {
        alert("스튜디오를 입력해주세요")
        return
      }

      // 포즈 설명 검증
      else if (this.create.pose_type == "") {
        alert("포즈 설명을 입력해주세요")
        return
      }

      // 위치 설명 검증
      else if (this.create.standing_type == "") {
        alert("위치 설명을 입력해주세요")
        return
      }

      // 위치 설명 검증
      else if (this.create.shadow_json == "") {
        alert("새도우값을 입력해주세요")
        return
      }

      // 태그 검증
      // if (this.create.maker.toString() == "") {
      //     alert("메이커를 입력해주세요")
      //     return
      // }

      // 이미지 업로드 (DB 입력)
      await this.imageUpload()
    },

    clear(lang = "ko") {
      if (lang === "ko") {
        this.options.content = ""
        this.componentKey++
      } else if (lang === "en") {
        this.en.options.content = ""
        this.en.componentKey++
      } else if (lang === "jp") {
        this.jp.options.content = ""
        this.jp.componentKey++
      }
    },
  },
}
</script>
<style scoped>
.my-clipper {
  width: 100%;
}

.placeholder {
  width: 100%;
  height: 150px;
}
</style>
